<div class="container">
  <mic-breadcrumb id="finished-product-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/setup/siteSetup" label="{{ translationService.translate('siteSetupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }} Details"></mic-breadcrumb-link>
  </mic-breadcrumb>
  <form [formGroup]="siteDetailsForm">
    <div class="flex items-center justify-between mt-3 mb-4">
      <h2 class="page-title m-0" id="casing-size-heading">{{ translationService.translate('siteSetupText') }}</h2>
      <div class="action-buttons">
        <mic-status class="primary pr-10">*Required Field</mic-status>
        <button
          id="add-button"
          type="button"
          mat-flat-button
          color="primary"
          class="btn-primary"
          (click)="save()"
          [matTooltip]="productSaveDisabled ? this.translationService.translate('comingSoonText') : null"
        >
          <mat-icon>save</mat-icon> {{ translationService.translate('saveLinkText') }}
        </button>
      </div>
    </div>
    <div class="mx-16">
      <mat-accordion>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder"></mic-icon>
              {{ translationService.translate('genericInformationText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>
          <div class="grid grid-rows-7 mt-3">
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="codeField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('codeText') }} </mat-label>
                <input id="siteCode" matInput type="text" required [formControlName]="'siteCode'" maxlength="3" />
                @if (siteDetailsForm.get('siteCode').hasError('required')) {
                <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
                } @if (siteDetailsForm.get('siteCode').hasError('siteCodeNotUnique')) {
                <mat-error>{{ translationService.translate('codeExistsText') }}</mat-error>
                }
              </mat-form-field>
              <div class="col-span-1 flex items-center gap-2 w-full justify-self-end">
                <p id="status-label" class="pr-5">{{ translationService.translate('activeText') }}</p>
                <mat-slide-toggle id="status-switch" formControlName="siteActive">
                  {{ translationService.translate('yesText') }}
                </mat-slide-toggle>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="nameField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('nameText') }} </mat-label>
                <input id="siteName" matInput type="text" required [formControlName]="'siteName'" maxlength="50" />
                @if (siteDetailsForm.get('siteName').hasError('required')) {
                <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
                }
              </mat-form-field>
              <mat-form-field appearance="fill" id="contactField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('contactText') }} </mat-label>
                <input id="contactName" matInput type="text" [formControlName]="'contactName'" maxlength="25" />
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="address1" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('addr1Text') }}</mat-label>
                <input id="address1" matInput type="text" [formControlName]="'addressOne'" maxlength="35" />
              </mat-form-field>
              <mat-form-field appearance="fill" id="emailField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('emailAddressText') }}</mat-label>
                <input id="email" matInput type="text" [formControlName]="'emailAdress'" maxlength="35" />
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="address2" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('addr2Text') }}</mat-label>
                <input id="address2" matInput type="text" [formControlName]="'addressTwo'" maxlength="35" />
              </mat-form-field>
              <mat-form-field appearance="fill" id="phoneField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('phoneNumberText') }}</mat-label>
                <input id="phoneNumber" matInput type="text" [formControlName]="'phoneNumber'" maxlength="20" />
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="cityField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('cityText') }}</mat-label>
                <input id="city" matInput type="text" [formControlName]="'city'" maxlength="20" />
              </mat-form-field>
              <mat-form-field appearance="fill" id="faxField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('faxNumberText') }}</mat-label>
                <input id="faxNumber" matInput type="text" [formControlName]="'faxNumber'" maxlength="20" />
              </mat-form-field>
            </div>
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="stateField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('stateText') }}</mat-label>
                <input id="state" matInput type="text" [formControlName]="'stateProvince'" maxlength="20" />
              </mat-form-field>
              <app-dropdown-multiple-search
                [editMode]="true"
                [multipleOption]="false"
                [id]="'country'"
                [formGroup]="siteDetailsForm"
                [controlName]="'countryCode'"
                [options]="countries"
                [label]="translationService.translate('customerCountryText')"
              />
            </div>
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="postalField" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('customerPostalCodeText') }}</mat-label>
                <input id="postalCode" matInput type="text" [formControlName]="'postalCode'" maxlength="20" />
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion>
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mic-icon class="mr-2" icon="folder"></mic-icon>
              {{ translationService.translate('settingsText') }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-divider></mat-divider>
          <div class="grid grid-rows-5 mt-3">
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="interface1Field" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('interfaceID1LabelText') }}</mat-label>
                <input id="interfaceId1" matInput type="text" [formControlName]="'interfaceId1'" maxlength="10" />
              </mat-form-field>
              <div class="grid grid-cols-3 gap-10 items-center">
                <p id="shipping-flag-label" class="pr-5">{{ translationService.translate('shippingFlagText') }}</p>
                <mat-radio-group formControlName="shipping" class="flex flex-row items-center gap-4">
                  <mat-radio-button id="shipping-manual-radio-button" [checked]="siteDetailsForm.get('shipping').value === 'Y'" value="Y">
                    {{ translationService.translate('manualText') }}
                  </mat-radio-button>
                  <mat-radio-button id="shipping-auto-radio-button" [checked]="siteDetailsForm.get('shipping').value === 'N'" value="N">
                    {{ translationService.translate('autoText') }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-10 items-center">
              <mat-form-field appearance="fill" id="interface2Field" class="col-span-1 w-full">
                <mat-label class="custom-label-error">{{ translationService.translate('interfaceID2LabelText') }}</mat-label>
                <input id="interfaceId2" matInput type="text" [formControlName]="'interfaceId2'" maxlength="10" />
              </mat-form-field>
              <div class="grid grid-cols-3 gap-10 items-center">
                <p id="receiving-flag-label" class="pr-5">{{ translationService.translate('receivingFlagText') }}</p>
                <mat-radio-group formControlName="receiving" class="flex flex-row items-center gap-4">
                  <mat-radio-button id="receiving-manual-radio-button" [checked]="siteDetailsForm.get('receiving').value === 'Y'" value="Y">
                    {{ translationService.translate('manualText') }}
                  </mat-radio-button>
                  <mat-radio-button id="receiving-auto-radio-button" [checked]="siteDetailsForm.get('receiving').value === 'N'" value="N">
                    {{ translationService.translate('autoText') }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="grid grid-cols-4 gap-10 items-center">
              <p id="scrap-label" class="pr-11">{{ translationService.translate('scrapShippingText') }}</p>
              <mat-slide-toggle id="scrap-switch" [formControlName]="'scrapShipping'">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
            <div class="grid grid-cols-4 gap-10 items-center">
              <p id="reject-casing-label" class="pr-6">{{ translationService.translate('rejByCasingText') }}</p>
              <mat-slide-toggle id="reject-casing-switch" [formControlName]="'rejectByCasingPost'">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
            <div class="grid grid-cols-4 gap-10 items-center">
              <p id="reject-customer-label" class="pr-4">{{ translationService.translate('rejByCustomerText') }}</p>
              <mat-slide-toggle id="reject-customer-switch" [formControlName]="'rejectByCustomerPost'">
                {{ translationService.translate('yesText') }}
              </mat-slide-toggle>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </form>

  <mic-modal class="modalC" #discardConfirmation>{{ translationService.translate('unSaveChangesText') }}</mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
